import { render, staticRenderFns } from "./GoldPriceView.vue?vue&type=template&id=c1c36c8e&scoped=true&"
import script from "./GoldPriceView.vue?vue&type=script&lang=js&"
export * from "./GoldPriceView.vue?vue&type=script&lang=js&"
import style0 from "./GoldPriceView.vue?vue&type=style&index=0&id=c1c36c8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c36c8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VTextField})
